/* eslint-disable */
export default {
  title: 'Spraakbericht sturen',
  customMessage: 'Aangepast bericht',
  customMessagePlaceholder: 'Een aangepast bericht invoeren',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
